import { useEffect, useState } from "react";
import axios from "axios";
import { GoPencil } from "react-icons/go";
import { TextField } from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Bounce, toast } from "react-toastify";

const Contact = () => {
  const [res, setRes] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [editMode2, setEditMode2] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [heroVideo, setHeroVideo] = useState("");
  const [heroVideoPreview, setHeroVideoPreview] = useState("");
  const token = localStorage.getItem("hiedberg_admin_token");

  const fetchData = async () => {
    try {
      setLoading(true);
      const result = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/contact/get`
      );
      setRes(result.data.data);
      console.log(result.data.data);
    } catch (error) {
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
      console.error("Error fetching no data", error);
    } finally {
      setLoading(false);
    }
  };
  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const videoUrl = URL.createObjectURL(file);
      setHeroVideo(file);
      setHeroVideoPreview(videoUrl);
    }
  };
  const validationSchema1 = Yup.object().shape({
    title1: Yup.string().required("Title 1 is required"),
    title2: Yup.string().required("Title 2 is required"),
    description: Yup.string().required("Description is required"),
    buttonText: Yup.string().required("Button Text is required"),
  });
  const validationSchema = Yup.object({
    title1: Yup.string().required("Title 1 is required"),
    title2: Yup.string().required("Title 2 is required"),
    description: Yup.string().required("Description is required"),
    buttonText: Yup.string().required("Button Text is required"),
  });
  const validationSchema22 = Yup.object({
    title: Yup.string().required("Title 1 is required"),
    videoUrl: Yup.string().url("Please add http or https in URL"),
  });
  const initialValues1 = {
    title1: res?.contact?.title1 || "",
    title2: res?.contact?.title2 || "",
    description: res?.contact?.description || "",
    buttonText: res?.contact?.buttonText || "",
  };
  const initialValues = {
    title1: res.section1?.title1 || "",
    title2: res.section1?.title2 || "",
    description: res.section1?.description || "",
    buttonText: res.section1?.buttonText || "",
  };
  const initialValues22 = {
    title: res?.hero?.title || "",
    videoUrl: res.hero?.videoUrl || "",
  };
  const section1handleSubmit2 = async (values) => {
    try {
      setLoading(true);
      const payload = {
        section1: values,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/contact/update`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Section1 updated:", response.data);
      setEditMode(false);
      fetchData();
      toast.success("Section 1 updated successfully", {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
    } catch (error) {
      console.error(
        "Section1 Update Error:",
        error.response?.data || error.message
      );
    } finally {
      setLoading(false);
    }
  };
  const contecthandleSubmit1 = async (values) => {
    try {
      setLoading(true);
      const payload = {
        contact: values,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/contact/update`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Contact updated:", response.data);
      setEditMode2(false);
      fetchData();
      toast.success("Contact section updated successfully", {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
    } catch (error) {
      console.error(
        "Contact Update Error:",
        error.response?.data || error.message
      );
    } finally {
      setLoading(false);
    }
  };
  const herohandleSubmit = async (values) => {
    try {
      setLoading(true);
      let uploadedVideoUrl = res.hero?.videoUrl || "";
      if (heroVideo) {
        const formData = new FormData();
        formData.append("file", heroVideo);
        const uploadRes = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/upload`,
          formData
        );
        uploadedVideoUrl = uploadRes.data.data.publicUrl;
      }
      const payload = {
        hero: {
          ...values,
          videoUrl: uploadedVideoUrl,
        },
      };
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/contact/update`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setIsEditing(false);
      fetchData();
      toast.success("Hero section updated successfully", {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
    } catch (error) {
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
      console.error("Error response:", error.response?.data || error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      {loading ? (
        <div className="flex justify-center py-10">
          <div className="h-6 w-6 animate-spin rounded-full border-t-2 border-blue-500"></div>
        </div>
      ) : (
        <div className="mt-5 space-y-4 overflow-auto pb-6">
          <div className="rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
            <Formik
              validationSchema={validationSchema22}
              enableReinitialize
              initialValues={initialValues22}
              onSubmit={herohandleSubmit}
            >
              {({ errors, touched, resetForm }) => (
                <Form>
                  <div className="flex flex-col gap-y-4">
                    <div className="flex items-start justify-between">
                      <h3 className="mb-4 text-lg font-semibold text-gray-800">
                        Hero Section
                      </h3>

                      {isEditing ? (
                        <div className="flex items-center gap-3">
                          <button
                            type="submit"
                            className="text-sm font-medium text-blue-600 hover:text-blue-800"
                          >
                            Save Changes
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              setIsEditing(false);
                              resetForm();
                            }}
                            className="text-sm font-medium text-gray-500 hover:text-gray-700"
                          >
                            Cancel
                          </button>
                        </div>
                      ) : (
                        <GoPencil
                          className="hover:text-black h-5 w-5 cursor-pointer"
                          onClick={() => setIsEditing(true)}
                        />
                      )}
                    </div>
                    <div className="rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
                      <h3 className="mb-4 text-lg font-semibold text-gray-800">
                        Hero Video
                      </h3>
                      <div className="flex flex-col gap-4">
                        <div className="group relative h-64 w-full overflow-hidden rounded-lg border border-gray-300">
                          {heroVideoPreview || res.hero?.videoUrl ? (
                            <video
                              src={heroVideoPreview || res.hero?.videoUrl}
                              className="h-full w-full object-cover"
                              controls
                              muted
                              autoPlay
                            />
                          ) : (
                            <div className="flex h-full w-full items-center justify-center bg-gray-100">
                              <span className="text-gray-500">
                                No video uploaded
                              </span>
                            </div>
                          )}
                          {isEditing && (
                            <>
                              <div className="bg-green absolute inset-0 flex items-center justify-center bg-[#353935] bg-opacity-65 opacity-0 transition duration-300 group-hover:opacity-100">
                                <GoPencil
                                  className="h-7 w-7 cursor-pointer text-white"
                                  onClick={() =>
                                    document
                                      .getElementById("heroVideoInput")
                                      .click()
                                  }
                                />
                              </div>
                              <input
                                type="file"
                                id="heroVideoInput"
                                accept="video/*"
                                className="hidden"
                                onChange={handleVideoChange}
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <Field
                      as={TextField}
                      name="title"
                      label="Title"
                      variant="outlined"
                      size="small"
                      slotProps={{ inputLabel: { shrink: true } }}
                      error={touched.title && Boolean(errors.title)}
                      helperText={touched.title && errors.title}
                      disabled={!isEditing}
                    />
                  </div>
                </Form>
              )}
            </Formik>
          </div>

          <div className="rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
            <Formik
              initialValues={initialValues1}
              enableReinitialize
              validationSchema={validationSchema1}
              onSubmit={contecthandleSubmit1}
            >
              {({ values, errors, touched, handleChange, resetForm }) => (
                <Form className="flex flex-col gap-y-4">
                  <div className="mb-2 flex items-center justify-between">
                    <h3 className="text-lg font-semibold text-gray-800">
                      Contact
                    </h3>

                    {editMode2 ? (
                      <div className="flex items-center gap-3">
                        <button
                          type="submit"
                          className="text-sm font-medium text-blue-600 hover:text-blue-800"
                        >
                          Save Changes
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            setEditMode2(false);
                            resetForm();
                          }}
                          className="text-sm font-medium text-gray-500 hover:text-gray-700"
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <GoPencil
                        className="hover:text-black h-5 w-5 cursor-pointer"
                        onClick={() => setEditMode2(true)}
                      />
                    )}
                  </div>

                  <TextField
                    name="title1"
                    label="Title 1"
                    variant="outlined"
                    size="small"
                    value={values.title1}
                    onChange={handleChange}
                    disabled={!editMode2}
                    error={touched.title1 && Boolean(errors.title1)}
                    helperText={touched.title1 && errors.title1}
                    slotProps={{ inputLabel: { shrink: true } }}
                  />

                  <TextField
                    name="title2"
                    label="Title 2"
                    variant="outlined"
                    size="small"
                    value={values.title2}
                    onChange={handleChange}
                    disabled={!editMode2}
                    error={touched.title2 && Boolean(errors.title2)}
                    helperText={touched.title2 && errors.title2}
                    slotProps={{ inputLabel: { shrink: true } }}
                  />

                  <TextField
                    name="description"
                    label="Description"
                    variant="outlined"
                    size="small"
                    value={values.description}
                    onChange={handleChange}
                    disabled={!editMode2}
                    error={touched.description && Boolean(errors.description)}
                    helperText={touched.description && errors.description}
                    slotProps={{ inputLabel: { shrink: true } }}
                  />

                  <TextField
                    name="buttonText"
                    label="Button Text"
                    variant="outlined"
                    size="small"
                    value={values.buttonText}
                    onChange={handleChange}
                    disabled={!editMode2}
                    error={touched.buttonText && Boolean(errors.buttonText)}
                    helperText={touched.buttonText && errors.buttonText}
                    slotProps={{ inputLabel: { shrink: true } }}
                  />
                </Form>
              )}
            </Formik>
          </div>

          <div className="rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              enableReinitialize
              onSubmit={section1handleSubmit2}
            >
              {({ values, errors, touched, handleChange, resetForm }) => (
                <Form id="section1-form" className="flex flex-col gap-y-4">
                  <div className="flex items-center justify-between">
                    <h3 className="mb-4 text-lg font-semibold text-gray-800">
                      Section 1
                    </h3>

                    {editMode ? (
                      <div className="flex items-center gap-3">
                        <button
                          type="submit"
                          className="text-sm font-medium text-blue-600 hover:text-blue-800"
                        >
                          Save Changes
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            setEditMode(false);
                            resetForm();
                          }}
                          className="text-sm font-medium text-gray-500 hover:text-gray-700"
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <GoPencil
                        className="hover:text-black h-5 w-5 cursor-pointer"
                        onClick={() => setEditMode(true)}
                      />
                    )}
                  </div>
                  <TextField
                    label="Title 1"
                    name="title1"
                    size="small"
                    variant="outlined"
                    value={values.title1}
                    onChange={handleChange}
                    disabled={!editMode}
                    error={touched.title1 && Boolean(errors.title1)}
                    helperText={touched.title1 && errors.title1}
                    fullWidth
                  />
                  <TextField
                    label="Title 2"
                    name="title2"
                    size="small"
                    variant="outlined"
                    value={values.title2}
                    onChange={handleChange}
                    disabled={!editMode}
                    error={touched.title2 && Boolean(errors.title2)}
                    helperText={touched.title2 && errors.title2}
                    fullWidth
                  />
                  <TextField
                    label="Description"
                    name="description"
                    size="small"
                    variant="outlined"
                    value={values.description}
                    onChange={handleChange}
                    disabled={!editMode}
                    error={touched.description && Boolean(errors.description)}
                    helperText={touched.description && errors.description}
                    fullWidth
                  />
                  <TextField
                    label="Button Text"
                    name="buttonText"
                    size="small"
                    variant="outlined"
                    value={values.buttonText}
                    onChange={handleChange}
                    disabled={!editMode}
                    error={touched.buttonText && Boolean(errors.buttonText)}
                    helperText={touched.buttonText && errors.buttonText}
                    fullWidth
                  />
                </Form>
              )}
            </Formik>
          </div>
        </div>
      )}
    </>
  );
};

export default Contact;
